/*
 * @Description: 
 * @Author: 赵大壮
 * @Date: 2021-11-25 13:05:57
 * @LastEditTime: 2021-12-11 14:40:41
 * @LastEditors: 赵大壮
 */
import Vue from 'vue';
import Vuex from 'vuex';
import DZModelUser from "@/model/DZModelUser"

Vue.use(Vuex);

export default new Vuex.Store({

  state: {
    city: [],
    user: new DZModelUser(),
    collapseStatus: false
  },
  mutations: {
    SET_USER(state, userData) {
      var new_user = new DZModelUser();
      new_user.parse(userData);
      state.user = new_user;
    },
    CHANGE_COLLAPSE_STATUS(state, status) {
      state.collapseStatus = status;
    }
  },
  actions: {
  },
  modules: {

  },
});
